// ----------------------------------------------------------------------

export function getFile(response, name, type = "application/pdf") {
    try {
        const { status, data: stream, headers } = response;

        let blob;
        let url;
        let downloadFileName = name;

        if (status === 200 && stream) {
            blob = new Blob([stream], { type });
            url = window.URL.createObjectURL(blob);

            if (headers["content-disposition"])
                downloadFileName = headers["content-disposition"].split(";")[2].split("filename=")[1].replaceAll("\"", "");
        }

        return {
            file: blob,
            url,
            name: downloadFileName
        };
    } catch (e) {
        console.log(e);
        //
        return null;
    }
}

export function downloadURL(url, filename) {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename || "download";
    anchor.target = "_blank";

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

export function getFileURL(stream, type = "application/pdf") {
    if (!stream) return "";

    const blob = new Blob([stream], { type });

    const url = window.URL.createObjectURL(blob);

    if (isValidURL(url)) return url;
    return "";
}

export function openFile(stream, type = "application/pdf") {
    const url = getFileURL(stream, type);

    if (url) window.open(url);
}

export function isValidURL(str) {
    try {
        // eslint-disable-next-line no-new
        new URL(str);
        return true;
    } catch (_) {
        return false;
    }
}
